module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - Road to Enlightenment (load_1).088ed686.txt";